/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-video-add': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.25 9.375h-2.5v-2.5H7.5v2.5H5v1.25h2.5v2.5h1.25v-2.5h2.5v-1.25zm1.875 6.875H2.5c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h10.625c.69 0 1.25.56 1.25 1.25v2.536l3.387-2.42a.625.625 0 01.988.509v8.75a.625.625 0 01-.988.509l-3.387-2.419V15c0 .69-.56 1.25-1.25 1.25zM2.5 5v10h10.625v-3.75a.625.625 0 01.988-.509L17.5 13.16V6.84l-3.387 2.419a.625.625 0 01-.988-.509V5H2.5z"/>'
  }
})
